import gql from 'graphql-tag';

export const GET_SERVICE_REQUEST_INCORRECT = gql`
	query GetServiceRequestIncorrect($id: String!) {
		serviceRequest(id: $id) {
			id
			notes
			requestedFiles {
				id
				type
				status
				allowFixRequest
				tags
				filename
				thumbnailUrl
				webUrl
				watermarkUrl
				isVisible
				width
				height
			}
			service {
				id
				type
				cubiCasaQuickEditLink
				cubiCasaAdvancedEditLink
				photographer {
					id
				}
			}
		}
	}
`;
